import { componentResolverFromMap } from "gatsby-plugin-prismic-previews";

export const repositoryConfig = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
    componentResolver: componentResolverFromMap(),
  },
];
